function getDefaultApiBase() {
  if (typeof window === "undefined") return "";

  const hostname = window.location.hostname;
  if (
    process.env.NODE_ENV === "development" ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  ) {
    return process.env.REACT_APP_API_BASE || "http://localhost:8080";
  }

  return "";
}

export const API_BASE = process.env.REACT_APP_API_BASE || getDefaultApiBase();

export function apiUrl(path = "") {
  if (!path) return API_BASE;
  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
